// !!if env is QA then import from qa file on line 2
import { BASE_URL, USER_API, NATIVE_APP_URL, MIXPANEL_TOKEN, GOOGLE_ANALYTICS_TOKEN, RESET_PWD_LINK, FIREBASE_CONFIG, FIREBASE_VAPID_KEY } from "../constant/app.qa.constant";
const MESSAGE_METADATA = `${USER_API}/message/metadata`;
const UPDATE_TEXT_TO_PAY_PREFERENCE =  `${USER_API}/authorisation-requests-updateTextToPay`;

const MIXPANEL_URL = 'https://api.mixpanel.com/track?ip=1&verbose=1';

const RSA_PUBLIC_KEY = 'LS0tLS1CRUdJTiBQVUJMSUMgS0VZLS0tLS1NSUdmTUEwR0NTcUdTSWIzRFFFQkFRVUFBNEdOQURDQmlRS0JnUUM0bzg2a3lMNlVRVnp5eVZidkp2Y1o4NStmcmYyazdIeGl4U2NMazN0bm5lenhHeXNVTGZPWm1US2VwL3JaVGlHMDFzT0lhaUk0dEVEOWxVbVFCTU1vbzd5RlhlazA1ZVR1RXR5bTZuc1MzODRuVnJkbEJDeERxUzlRN1Q1VnZJUDJ0R05BRVFucW5tVERBM3c2Uzh2WjdWSWdWVkZKTlMyVVpYQWsxeGpkOFFJREFRQUItLS0tLUVORCBQVUJMSUMgS0VZLS0tLS0=';
const GOOGLE_AUTHKEY = "529507144249-u08vk1l6gebqvp38pid649am7lben1bi.apps.googleusercontent.com";
const GOOGLE_AUTHKEY_ANDROID_NATIVE = "529507144249-vpt7682d9inh51fdbq497aqh1kmha9eg.apps.googleusercontent.com";
const GOOGLE_AUTHKEY_IOS_NATIVE = "529507144249-8s9g37bb8ev63vcnf9nov0euh8aqh499.apps.googleusercontent.com";
const EXPO_AUTHKEY_NATIVE = "529507144249-g6o06ahmboqf9759dmr16r5kcfc4kro3.apps.googleusercontent.com";
const AMAZON_AUTHKEY = "amzn1.application-oa2-client.b89ecad71c9a4260897eac00fe31a3b8";
const APPLE_AUTHKEY = "com.exelaonline.XBPApplication";
const EXPO_PUBLIC_MERCHANT_IDENTIFIER = 'bWVyY2hhbnQuY29tLnhicHBheXVrLmFwcGxpY2F0aW9u';
export {
  BASE_URL,
  USER_API,
  RSA_PUBLIC_KEY,
  GOOGLE_AUTHKEY,
  APPLE_AUTHKEY,
  AMAZON_AUTHKEY,
  GOOGLE_AUTHKEY_ANDROID_NATIVE,
  GOOGLE_AUTHKEY_IOS_NATIVE,
  EXPO_AUTHKEY_NATIVE,
  NATIVE_APP_URL,
  UPDATE_TEXT_TO_PAY_PREFERENCE,
  MESSAGE_METADATA,
  MIXPANEL_URL,
  MIXPANEL_TOKEN,
  GOOGLE_ANALYTICS_TOKEN,
  RESET_PWD_LINK,
  FIREBASE_CONFIG,
  FIREBASE_VAPID_KEY,
  EXPO_PUBLIC_MERCHANT_IDENTIFIER
};